module.exports = __webpack_public_path__ + "img/support-bs-cta-desktop.bad7165.jpg";